// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { AuthData } from '../model';
import { ProfileDto } from '../model/profile.model';


export const authRefreshToken = createAction('[Auth] Refresh token', props<{ authData: AuthData }>());
export const authLoginSuccess = createAction('[Auth] Login success', props<{ profile: ProfileDto }>());
export const authResetPassword = createAction('[Auth] Reset password', props<{ username: string }>());
export const authResetPasswordFailed = createAction('[Auth] Reset password failed', props<{ error: string }>());
export const authResetPasswordSuccess = createAction('[Auth] Reset password success', props<{ username: string }>());

export const authReauthorize = createAction('[Auth] Reauthorize');
export const authLoginByCredentials = createAction('[Auth] Login by credentials', props<{ login: string, password: string }>());
export const authLoginByCredentialsSuccess = createAction('[Auth] Login by credentials success', props<{ authData: AuthData }>());
export const authChangePassword = createAction('[Auth] Change password', props<{ username: string, currentPassword: string, newPassword: string }>());
export const authChangePasswordFailure = createAction('[Auth] Change password failure', props<{ error: string }>());
export const authChangePasswordSuccess = createAction('[Auth] Change password success');
export const authLogout = createAction('[Auth] logout');

export const userRestored = createAction('[Auth] User restored', props<{ profileDto: ProfileDto }>());
